import { render, staticRenderFns } from "./ImportTariffZones.vue?vue&type=template&id=35c33308&"
import script from "./ImportTariffZones.vue?vue&type=script&lang=ts&"
export * from "./ImportTariffZones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports